import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import {MatButtonModule} from "@angular/material/button";
import {NgClass} from "@angular/common";
import {NgClassType} from "../../model/common.model";
import { Location } from "@angular/common";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'back-button',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    NgClass
  ],
  templateUrl: './back-button.component.html',
})
export class BackButtonComponent {

  @Input() ngClass: NgClassType

  constructor(
    readonly router: Router,
    readonly location: Location
  ) {
  }
}
